import type { IconSvgObject } from './types';

const StrokeTopIcon: IconSvgObject = [
  ["path", { d: "M19 7L19 19C19 20.1046 18.1046 21 17 21L7 21C5.89543 21 5 20.1046 5 19V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 2.99805L3 2.99805", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StrokeTopIcon;
